import React, { useState } from 'react'
import { ethers } from 'ethers'
import { MiningPoolAbi } from '../../../../utils/config'
import { useTranslation } from 'react-i18next'
import { getSelectedWalletEthersProvider } from '../../../../utils/selectedWalletProvider'
import ConsoleDialog from '../../../StakingConsole/ConsoleDialog'
import { mapStakingError } from '../../../StakingConsole/errorMessages'
import { buildWhitelistPlan } from '../../transactionPlan'
import { waitForTransaction } from '../../../StakingConsole/transactionFeedback'

export default function WhitelistModal(props) {
    const [currentTab, setCurrentTab] = useState('add')
    const [addressInput, setAddressInput] = useState('')
    const [submitLoading, setSubmitLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState('')
    const { t } = useTranslation()
    const submit = async () => {
        setErrorMsg('')
        const addresses = addressInput.split('\n').map((value) => value.trim()).filter(Boolean)
        const invalidLine = addresses.findIndex((value) => value.length !== 42 || value.indexOf('0x') !== 0)
        if (invalidLine > -1) return setErrorMsg(t('第1行的地址格式不正确').replace('{line}', invalidLine + 1))
        setSubmitLoading(true)
        try {
            const contract = new ethers.Contract(props.poolAddress, MiningPoolAbi, getSelectedWalletEthersProvider(props.chainId).getSigner())
            const plan = buildWhitelistPlan(addresses, currentTab === 'add')
            const tx = await contract[plan.method](...plan.args)
            const result = await waitForTransaction(tx)
            props.ok && props.ok({
                ...result,
                title: currentTab === 'add' ? t('白名单添加成功') : t('白名单移除成功'),
                description: t('白名单配置已经链上确认。'),
            })
        } catch (error) { setErrorMsg(mapStakingError(error, t)) }
        setSubmitLoading(false)
    }
    return <ConsoleDialog show={props.show} onClose={props.handleClose} closeLabel={t('关闭')} title={t('设置白名单')} description={t('批量添加或移除可直接参与推广的钱包')} icon="fa-list" footer={<button type="button" className="console-button console-button--primary" disabled={submitLoading} onClick={submit}>{submitLoading ? t('处理中...') : t('提交')}</button>}>
        <p className="console-info-note">{t('白名单账号无需质押, 即可享受下级推荐算力提升, 非白名单必须质押后才可邀请下级享受算力提升')}</p>
        <div className="console-tabs"><button type="button" className={currentTab === 'add' ? 'is-active' : ''} onClick={() => setCurrentTab('add')}>{t('添加白名单')}</button><button type="button" className={currentTab === 'remove' ? 'is-active' : ''} onClick={() => setCurrentTab('remove')}>{t('移除白名单')}</button></div>
        <label className="console-form-label" htmlFor="whitelist-addresses">{currentTab === 'add' ? t('添加白名单') : t('移除白名单')}</label><textarea id="whitelist-addresses" className="console-textarea" rows="7" value={addressInput} onChange={(event) => setAddressInput(event.target.value)} placeholder={t('输入要设置的钱包地址, 每行一个地址')} />
        {errorMsg && <p className="console-form-error" role="alert">{errorMsg}</p>}
    </ConsoleDialog>
}
